import dataLayerPush from './DataLayer';

export default function lineItem(dataJsonString: string) {
  const data = JSON.parse(dataJsonString);
  return {
    data,
    updateCart(event: string) {
      dataLayerPush({
        event,
        ecommerce: {
          currency: 'EUR',
          value: this.data.price,
          items: [{
            item_brand: 'Driessen stoffen',
            ...this.data,
          }],
        },
      });
    },
  };
}
